import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { AlertController, ModalController, Platform } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { distinctUntilChanged, filter, first, Subscription } from "rxjs";
import { DataStorageService } from "src/app/services/data-storage/data-storage.service";
import * as fromApp from "../../store/app.reducer";
import * as selectors from "../../store/app.selectors";
import * as _ from "lodash";
import * as DeliveryMethodAddressActions from "../../store/deliveryMethodAddress/deliveryMethodAddress.actions";
import * as currentStoresActions from "../../store/current-store/current-store.actions";
import { Router } from "@angular/router";
import { SelectStorePopupComponent } from "../select-store-popup/select-store-popup.component";
import { DineinValidationsService } from "src/app/services/dineInValidations/dinein-validations.service";
import * as AuthActions from "../../auth/store/auth.actions";
import { Capacitor } from "@capacitor/core";
import { AnalyticsServiceService } from "src/app/services/analitycsService/analytics-service.service";
import { DineinTableLabelService } from "../../services/dinein-table-label/dinein-table-label.service";
import { DineinTableLabelContext } from "../../services/dinein-table-label/dinein-table-label.helpers";

@Component({
  selector: "app-dine-in-modal",
  templateUrl: "./dine-in-modal.component.html",
  styleUrls: ["./dine-in-modal.component.scss"],
})
export class DineInModalComponent implements OnInit, OnDestroy {
  @Input() selectedTableIdFromLink;
  @Input() selectedStoreFromLink;
  @Input() selectedStoreFromParent;
  @Input() dineInSourceFromLink;
  // This modal's own ion-modal host, set by Ionic's ModalController.
  @Input() modal: HTMLIonModalElement;
  public selectedTableFromLinkObject: any;
  public selectedTableId: any;
  public tables: any;
  public orderPickup;
  public dineIn;
  public selectedAddress;
  public selectedPreorderDate;
  public selectedStoreId: any;
  public selectedDineInTable: any;
  public stores: any;
  public currentStoreId: any;
  public selectedLangugage: any;
  public storeInfo: any;
  public fetchTablesLoading;
  public selectedStore;
  public displayOnlySpinner: boolean = false;
  public onlyDineInModeTable: boolean = false;
  public currentUser: any;
  public mandatoryWebOnlyDineInModal = false;

  // Shared by every instance on purpose — see the increment site in
  // setDineInAndSelectedTable.
  private static dineInAuthAttemptSeq = 0;

  private groupApp: any;
  private auth_key: any;
  private subscriptions: Subscription[] = [];
  private dineInScanRecognitionAlertPresented = false;
  private autoSubmitStarted = false;
  private readonly autoSubmitMaxWaitMs = 3000;

  private unsubscribeBackEvent: Subscription;
  public dineinTableContext: DineinTableLabelContext = null;
  private dineinTableContextSub: Subscription;

  constructor(
    private modalController: ModalController,
    private dataStorageService: DataStorageService,
    private translateService: TranslateService,
    private alertController: AlertController,
    private dineInValidationsService: DineinValidationsService,
    private router: Router,
    private store: Store<fromApp.AppState>,
    private platform: Platform,
    private analyticsService: AnalyticsServiceService,
    private dineinTableLabelService: DineinTableLabelService
  ) {}

  ngOnInit() {
    this.dineinTableContextSub =
      this.dineinTableLabelService.context$.subscribe((context) => {
        this.dineinTableContext = context;
      });
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      200,
      () => {
        if (this.platform.is("android") && !this.mandatoryWebOnlyDineInModal) {
          this.closeModal();
        }
      }
    );

    this.subscriptions.push(
      this.store
        .select("auth")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(state.user, this.currentUser)) {
            this.currentUser = _.cloneDeep(state.user);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("groupApp")
        .pipe(distinctUntilChanged())
        .subscribe(async (state) => {
          if (
            state &&
            state.selectedLangugage &&
            !_.isEqual(state.selectedLangugage, this.selectedLangugage)
          ) {
            this.selectedLangugage = _.cloneDeep(state.selectedLangugage);
          }

          if (
            state &&
            state.groupApp &&
            !_.isEqual(state.groupApp, this.groupApp)
          ) {
            this.groupApp = _.cloneDeep(state.groupApp);
          }
        })
    );

    if (this.selectedStoreFromLink) {
      this.displayOnlySpinnerEnabled();
      this.selectedStoreId = _.cloneDeep(this.selectedStoreFromLink);
      this.fetchDineInTablesThrottle(this.selectedStoreId);

      console.log("selected store id from link", this.selectedStoreId);
    }

    console.log("selected store id from parent", this.selectedStoreFromParent);

    if (!this.selectedStoreFromLink && this.selectedStoreFromParent) {
      this.displayOnlySpinnerEnabled();
      this.selectedStoreId = _.cloneDeep(this.selectedStoreFromParent.store_id);
      this.selectedStore = _.cloneDeep(this.selectedStoreFromParent);
      this.updateMandatoryWebOnlyDineInModal();
      this.fetchDineInTablesThrottle(this.selectedStoreFromParent.store_id);

      console.log(
        "selected store id from selectStoreFromParent",
        this.selectedStoreFromParent
      );
    }

    this.subscriptions.push(
      this.store
        .select("stores")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && state.stores && !_.isEqual(state.stores, this.stores)) {
            this.stores = _.cloneDeep(state.stores);
            if (this.selectedStoreId && this.stores) {
              this.selectedStore = this.findStoreById(this.selectedStoreId);
              this.updateMandatoryWebOnlyDineInModal();
            }
            if (
              this.stores &&
              this.stores.length &&
              this.stores.length === 1 &&
              !this.selectedStoreFromLink
            ) {
              this.displayOnlySpinnerEnabled();
              this.store
                .select("currentStore")
                .pipe(first())
                .subscribe(async (state) => {
                  if (state && state.currentStoreId) {
                    if (!this.selectedStoreId) {
                      this.selectedStoreId = _.cloneDeep(state.currentStoreId);
                      this.selectedStore = this.findStoreById(
                        this.selectedStoreId
                      );
                      this.updateMandatoryWebOnlyDineInModal();
                    }

                    this.fetchDineInTablesThrottle(state.currentStoreId);
                  } else {
                    const alert = await this.alertController.create({
                      header: this.translateService.instant("alert"),
                      message: this.translateService.instant(
                        "errorMessages.problem_reaching_server"
                      ),

                      buttons: ["OK"],
                    });
                    await alert.present();
                  }
                })
                .unsubscribe();
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("currentStore")
        .pipe(distinctUntilChanged())
        .subscribe(async (state) => {
          if (state && !_.isEqual(state.currentStoreId, this.currentStoreId)) {
            this.currentStoreId = _.cloneDeep(state.currentStoreId);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select(selectors.getStoreInfo)
        .pipe(distinctUntilChanged())
        .subscribe((storeInfo) => {
          if (storeInfo && !_.isEqual(storeInfo, this.storeInfo)) {
            this.storeInfo = _.cloneDeep(storeInfo);
            this.updateMandatoryWebOnlyDineInModal();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("deliveryMethodAddress")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(this.dineIn, state.dineIn)) {
            this.dineIn = _.cloneDeep(state.dineIn);
          }
          if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
            this.orderPickup = _.cloneDeep(state.orderPickup);
          }
          if (
            state &&
            !_.isEqual(this.selectedAddress, state.selectedAddress)
          ) {
            this.selectedAddress = _.cloneDeep(state.selectedAddress);
          }
          if (
            state &&
            !_.isEqual(this.selectedPreorderDate, state.selectedPreorderDate)
          ) {
            this.selectedPreorderDate = _.cloneDeep(state.selectedPreorderDate);
          }
          if (
            state &&
            !_.isEqual(this.selectedDineInTable, state.selectedDineInTable) &&
            !this.selectedStoreFromLink
          ) {
            this.selectedDineInTable = _.cloneDeep(state.selectedDineInTable);
            if (!this.selectedTableId && this.selectedDineInTable) {
              this.selectedTableId = _.cloneDeep(
                this.selectedDineInTable.table_id
              );

              this.initOnlyDineInModeTable();
            }
          }
        })
    );
  }

  closeModal() {
    this.modalController.dismiss();
  }

  private updateMandatoryWebOnlyDineInModal() {
    const selectedStore = this.selectedStore || this.storeInfo;
    const validLinkedTable = !!(
      this.selectedTableIdFromLink &&
      this.selectedTableId &&
      this.selectedTableFromLinkObject
    );

    this.mandatoryWebOnlyDineInModal = !!(
      selectedStore &&
      selectedStore.dinein &&
      selectedStore.dine_in_disable_table_selection &&
      selectedStore.only_visitors_app &&
      !selectedStore.onlyAppsDineIn &&
      !Capacitor.isNativePlatform() &&
      validLinkedTable
    );
  }

  initOnlyDineInModeTable() {
    if (this.selectedTableId && this.selectedDineInTable) {
      this.onlyDineInModeTable = !!_.cloneDeep(
        this.selectedDineInTable &&
          this.selectedDineInTable.connected_mobile &&
          this.selectedDineInTable.table_id != null &&
          this.selectedDineInTable.table_id.toString() ===
            this.selectedTableId.toString()
      );
    }
  }

  checkOnlyDineInModeTable() {
    this.onlyDineInModeTable = false;
    if (this.selectedTableId && this.tables) {
      this.onlyDineInModeTable = !!_.find(this.tables, (table) => {
        if (
          this.shouldUseOnlyDineInModeForTable(table) &&
          table.table_id != null &&
          table.table_id.toString() === this.selectedTableId.toString()
        ) {
          return table;
        }
      });
    }
  }

  selectingTable(ev) {
    console.log("table selection", this.selectedTableId);
    this.checkOnlyDineInModeTable();
  }

  changeStore(ev) {
    this.tables = null;
    this.onlyDineInModeTable = false;
    if (this.selectedStoreId && this.stores) {
      this.selectedStore = this.findStoreById(this.selectedStoreId);
      this.updateMandatoryWebOnlyDineInModal();

      if (
        this.selectedStore &&
        this.selectedStore.dine_in_disable_table_selection
      ) {
        this.modalController.dismiss({
          type: "dine_in_disable_table_selection_store",
          store_id: this.selectedStore.store_id,
        });
      }
    }

    this.fetchDineInTablesThrottle(this.selectedStoreId);
  }

  clickOkAsGuest() {}

  async clickOkButton(onlyDineInMode, autoSubmit = false) {
    if (this.stores && this.stores.length && this.stores.length === 1) {
      let selectedTable = this.findTableById(this.selectedTableId);

      this.submitSelectedTable(selectedTable, onlyDineInMode, autoSubmit);
    } else if (this.stores && this.stores.length && this.stores.length > 1) {
      //HANDLE FOR DIFFERENT STORES

      if (
        this.selectedStoreId &&
        this.selectedStoreId !== this.currentStoreId
      ) {
        let selectedTable = this.findTableById(this.selectedTableId);
        if (selectedTable) {
          this.store.dispatch(
            new currentStoresActions.SetCurrentStoreId(
              _.cloneDeep(this.selectedStoreId)
            )
          );

          this.submitSelectedTable(selectedTable, onlyDineInMode, autoSubmit);
        } else {
          if (autoSubmit) {
            this.displayOnlySpinnerDisabled();
          }
          this.sendDineInFootprint("dinein_table_selection_result", "missing_table", {
            only_dinein_mode: !!onlyDineInMode,
          });
          const alert = await this.alertController.create({
            header: this.translateService.instant("alert"),
            message: this.dineinTableLabelService.instant(
              "errorMessages.please_select_a_dinein_table"
            ),

            buttons: ["OK"],
          });
          await alert.present();
        }
      } else {
        let selectedTable = this.findTableById(this.selectedTableId);

        if (selectedTable) {
          this.submitSelectedTable(selectedTable, onlyDineInMode, autoSubmit);
        } else {
          if (autoSubmit) {
            this.displayOnlySpinnerDisabled();
          }
          this.sendDineInFootprint("dinein_table_selection_result", "missing_table", {
            only_dinein_mode: !!onlyDineInMode,
          });
          const alert = await this.alertController.create({
            header: this.translateService.instant("alert"),
            message: this.dineinTableLabelService.instant(
              "errorMessages.please_select_a_dinein_table"
            ),

            buttons: ["OK"],
          });
          await alert.present();
        }
      }
    }
  }

  private setDineInAndSelectedTableDebounced = _.debounce(
    (selectedTable, onlyDineInMode) => {
      this.setDineInAndSelectedTable(selectedTable, onlyDineInMode);
    },
    300
  );

  private submitSelectedTable(selectedTable, onlyDineInMode, autoSubmit) {
    if (!autoSubmit) {
      this.setDineInAndSelectedTableDebounced(selectedTable, onlyDineInMode);
      this.modalController.dismiss();
      return;
    }

    void this.autoSubmitSelectedTable(selectedTable, onlyDineInMode);
  }

  // Used when fetchDineInTables finds a single table: there is nothing to
  // choose, so the card is not revealed (under the spinner it only flashed)
  // and the 300ms debounce + immediate dismiss, which showed the homepage
  // again before /catalog, are skipped. The table is set and, when that
  // navigated, the catalog page awaited, capped at autoSubmitMaxWaitMs,
  // before this modal is dismissed.
  private async autoSubmitSelectedTable(selectedTable, onlyDineInMode) {
    if (this.autoSubmitStarted) {
      return;
    }
    this.autoSubmitStarted = true;

    const catalogPageEnter = this.listenForCatalogPageEnter();
    let autoSubmitTimeout: ReturnType<typeof setTimeout> = null;
    try {
      await Promise.race([
        this.setDineInAndSelectedTable(selectedTable, onlyDineInMode).then(
          (navigatedToCatalog) => {
            if (navigatedToCatalog) {
              return catalogPageEnter.entered;
            }
          }
        ),
        new Promise((resolve) => {
          autoSubmitTimeout = setTimeout(resolve, this.autoSubmitMaxWaitMs);
        }),
      ]);
    } catch (e) {
      console.log("dine in auto submit failed", e);
    }
    clearTimeout(autoSubmitTimeout);
    catalogPageEnter.stop();

    try {
      await this.dismissOwnModal();
    } catch (e) {
      console.log("dine in auto submit dismiss failed", e);
    }
  }

  // navigateByUrl resolves before Ionic shows the page: the router outlet
  // first waits for the page's components and keeps it ion-page-invisible
  // (about 0.4s on a 4x slower CPU), so closing the spinner then showed the
  // homepage again. ionViewDidEnter comes right before the page is revealed
  // and does not bubble, hence the capture listener, added before navigating.
  private listenForCatalogPageEnter() {
    let catalogPageEntered = false;
    let resolveEntered: () => void = null;
    const entered = new Promise<void>((resolve) => {
      resolveEntered = resolve;
    });
    const listener = (event: Event) => {
      const page = event.target as HTMLElement;
      if (page && page.tagName === "APP-CATALOG" && !catalogPageEntered) {
        catalogPageEntered = true;
        resolveEntered();
      }
    };

    document.addEventListener("ionViewDidEnter", listener, true);

    return {
      entered,
      stop: () => {
        document.removeEventListener("ionViewDidEnter", listener, true);
      },
    };
  }

  // Ionic 6.7.5 ignores a dismiss() that comes before the modal has finished
  // presenting: it resolves false and the modal stays. A fast tables response
  // got here that early and left the spinner over the catalog for good, so
  // wait for the present and dismiss once more.
  private async dismissOwnModal() {
    if (!this.modal) {
      await this.modalController.dismiss();
      return;
    }

    if (await this.modal.dismiss()) {
      return;
    }

    await this.waitForOwnModalPresented();
    await this.modal.dismiss();
  }

  private waitForOwnModalPresented() {
    return new Promise<void>((resolve) => {
      let presentTimeout: ReturnType<typeof setTimeout> = null;
      const presented = () => {
        clearTimeout(presentTimeout);
        this.modal.removeEventListener("ionModalDidPresent", presented);
        resolve();
      };

      this.modal.addEventListener("ionModalDidPresent", presented);
      presentTimeout = setTimeout(presented, this.autoSubmitMaxWaitMs);
    });
  }

  waitingUserLogout() {
    return new Promise((resolve) => {
      this.store
        .select("auth")
        .pipe(
          filter((state) => state.user === null),
          first()
        )
        .subscribe(() => {
          resolve(true);
        });
    });
  }

  // Resolves true when it navigated from the homepage to /catalog.
  async setDineInAndSelectedTable(selectedTable, onlyDineInMode) {
    let navigatedToCatalog = false;
    if (selectedTable) {
      this.sendDineInFootprint("dinein_table_selection_result", "selected", {
        only_dinein_mode: !!onlyDineInMode,
      });

      if (
        this.currentUser &&
        this.currentUser.only_dinein &&
        !selectedTable.connected_mobile
      ) {
        this.store.dispatch(
          new AuthActions.SetLogoutFlagTimestamp(
            "do_not_navigate" + Date.now().toString()
          )
        );
      }

      if (onlyDineInMode && selectedTable.connected_mobile) {
        if (this.shouldLogoutBeforeOnlyDineInAuth(selectedTable)) {
          this.store.dispatch(
            new AuthActions.SetLogoutFlagTimestamp(
              "do_not_navigate" + Date.now().toString()
            )
          );

          await this.waitingUserLogout();
        }

        this.store.dispatch(new AuthActions.SetLoginState("login_loading"));
        // Identity of THIS attempt, so a callback that lands late can tell
        // whether it is still the current one. Counted on the class rather than
        // the instance because the modal is dismissed the moment the auth is
        // fired: a second attempt runs on a brand-new component, which an
        // instance field could never see.
        DineInModalComponent.dineInAuthAttemptSeq += 1;
        const authAttemptId = DineInModalComponent.dineInAuthAttemptSeq;
        const authAttemptStoreId =
          this.selectedStore && this.selectedStore.store_id != null
            ? this.selectedStore.store_id.toString()
            : null;
        this.dataStorageService
          .getOnlyDineInUserAuth(
            this.selectedStore.store_id,
            this.groupApp.group,
            selectedTable.connected_mobile,
            selectedTable.table_id,
            this.auth_key
          )
          .subscribe({
            next: async (res: any) => {
              if (!res || !res.success) {
                this.sendDineInFootprint("dinein_auth_result", "failed", {
                  only_dinein_mode: !!onlyDineInMode,
                });
                const alert = await this.alertController.create({
                  header: this.translateService.instant("alert"),
                  message:
                    (res && res.comment_id
                      ? this.translateService.instant(res.comment_id)
                      : this.translateService.instant(
                          "errorMessages.general_error"
                        )) + this.nextStepAfterFailedDineInAuth(),
                  backdropDismiss: false,
                  buttons: ["OK"],
                });

                await alert.present();

                this.store.dispatch(new AuthActions.SetLoginState("no_login"));
                this.reportTableKeptWithoutSession(
                  selectedTable,
                  onlyDineInMode,
                  "auth_failed"
                );
                this.rollbackDineInTableAfterFailedAuth(
                  selectedTable,
                  authAttemptId,
                  authAttemptStoreId
                );
              } else {
                this.sendDineInFootprint("dinein_auth_result", "success", {
                  only_dinein_mode: !!onlyDineInMode,
                });
                this.store.dispatch(new AuthActions.SetMoToken(res.token));
                // Marker so that a refresh — which loses the non-persisted
                // only_dinein token and logs the guest out — can be DETECTED and
                // reported, since the cart then restores the table with no user
                // behind it (the LOGIN/REGISTER dead-end). Purely diagnostic for
                // now: nothing acts on it. It records WHICH table the session
                // owns so a table selected afterwards is never misattributed,
                // and is removed on every guest-session end (real-login upgrade
                // and logoutErase). See loadDeliveryMethodAddress.
                // ts lets the reader tell a five-second refresh from a cold
                // start days later — without it every report looks the same.
                try {
                  if (selectedTable && selectedTable.table_id != null) {
                    window.localStorage.setItem(
                      "mo_dinein_active",
                      JSON.stringify({
                        table_id: selectedTable.table_id.toString(),
                        ts: Date.now(),
                      })
                    );
                  }
                } catch (e) {}
              }
            },
            error: async (error) => {
              this.sendDineInFootprint("dinein_auth_result", "error", {
                only_dinein_mode: !!onlyDineInMode,
              });
              const alert = await this.alertController.create({
                header: this.translateService.instant("alert"),
                message:
                  this.translateService.instant(
                    "errorMessages.problem_reaching_server"
                  ) + this.nextStepAfterFailedDineInAuth(),

                buttons: ["OK"],
              });
              await alert.present();

              this.store.dispatch(new AuthActions.SetLoginState("no_login"));
              this.reportTableKeptWithoutSession(
                selectedTable,
                onlyDineInMode,
                "auth_error"
              );
              this.rollbackDineInTableAfterFailedAuth(
                selectedTable,
                authAttemptId,
                authAttemptStoreId
              );
              return error;
            },
          });
      }

      this.store.dispatch(
        new DeliveryMethodAddressActions.setSelectedDineInTable(selectedTable)
      );
      this.store.dispatch(new DeliveryMethodAddressActions.setDineIn(true));
      this.store.dispatch(
        new DeliveryMethodAddressActions.setOrderPickup(false)
      );
      this.store.dispatch(
        new DeliveryMethodAddressActions.setValidDeliveryAreas(null)
      );
      this.store.dispatch(
        new DeliveryMethodAddressActions.setCarTakeawayPlateNumber(null)
      );
      this.store.dispatch(
        new DeliveryMethodAddressActions.setCarTakewayComments(null)
      );

      if (this.selectedAddress) {
        this.store.dispatch(
          new DeliveryMethodAddressActions.setCheckSelectedAddress(null)
        );
        this.store.dispatch(
          new DeliveryMethodAddressActions.setSelectedAddress(null)
        );
      }
      if (this.selectedPreorderDate) {
        this.store.dispatch(
          new DeliveryMethodAddressActions.setSelectedPreorderDate(null)
        );
      }
      if (navigator.cookieEnabled) {
        if (localStorage.getItem("deliveryMethodAddress")) {
          localStorage.removeItem("deliveryMethodAddress");
        }

        let deliveryMethodAddress = {
          orderPickup: false,
          dineIn: true,
          selectedDineInTable: selectedTable,
        };
        window.localStorage.setItem(
          "deliveryMethodAddress",
          JSON.stringify(deliveryMethodAddress)
        );
      }
      this.dineInValidationsService.setDineInOrderStartTimestamp();

      // The auth above is not awaited, so the table has just been set and
      // persisted whether or not a guest session was ever obtained. When no auth
      // was even attempted, report it here; the failure branches report their own
      // outcome once the response lands.
      if (!(onlyDineInMode && selectedTable.connected_mobile)) {
        this.reportTableKeptWithoutSession(
          selectedTable,
          onlyDineInMode,
          !onlyDineInMode ? "not_dinein_mode" : "no_connected_mobile"
        );
      }

      if (
        this.router &&
        this.router.url &&
        _.includes(_.cloneDeep(this.router.url), "homepage")
      ) {
        // Awaited for the auto submit, which dismisses the modal only once
        // /catalog is on screen. Caught so nothing escapes from here either.
        try {
          navigatedToCatalog = !!(await this.router.navigateByUrl("/catalog", {
            replaceUrl: true,
          }));
        } catch (e) {
          console.log("dine in catalog navigation failed", e);
        }
      }
    }
    return navigatedToCatalog;
  }

  // Diagnostic only — nothing is dispatched and no state is touched.
  //
  // setDineInAndSelectedTable sets and persists the table immediately, outside
  // the getOnlyDineInUserAuth callback, so an auth that fails (or never runs)
  // leaves a persisted dine-in table with nobody logged in and the cart falls
  // back to LOGIN/REGISTER. That is the reported symptom, and unlike a session
  // lost after a successful auth it writes no mo_dinein_active marker — so
  // neither dangling probe can see it. Measured on dev 13/08: a reload after a
  // SUCCESSFUL auth always reports no_delivery_method (the table does not
  // survive), which is what makes this path the remaining candidate.
  //
  // Emitted ungated via dmAnalyticsCustomMessage rather than through
  // sendDineInFootprint, which only fires for QR/link arrivals.
  private reportTableKeptWithoutSession(selectedTable, onlyDineInMode, reason) {
    // Nothing here may throw. One call site sits immediately before the
    // navigateByUrl("/catalog") that follows a table selection, so an escaping
    // error would strand the customer on the homepage — a behaviour change,
    // which this must not make.
    try {
      let hasUser = false;
      this.store
        .select("auth")
        .pipe(first())
        .subscribe((authState: any) => {
          hasUser = !!(authState && authState.user);
        })
        .unsubscribe();
      if (hasUser) {
        // Somebody is logged in — guest or normal account. The cart shows their
        // details, not LOGIN/REGISTER, so this is not the reported state. Only
        // the no-user case is worth a row, and this also keeps every ordinary
        // logged-in table selection out of the data.
        return;
      }

      this.analyticsService.dmAnalyticsCustomMessage("dinein_auth_result", {
        store_id:
          this.selectedStore && this.selectedStore.store_id
            ? this.selectedStore.store_id
            : null,
        table_id:
          selectedTable && selectedTable.table_id != null
            ? selectedTable.table_id.toString()
            : null,
        source: "table_kept_no_session",
        result: reason,
        only_dinein_mode: !!onlyDineInMode,
      });
    } catch (e) {}
  }

  // The way back differs by store, so a single sentence would be wrong for
  // somebody. A dine_in_disable_table_selection store has no table picker at
  // all — its customers arrive by QR only — so telling them to pick a table
  // again is advice they cannot act on; conversely a store with a picker has no
  // QR to rescan. Both keys already exist in all seven locales.
  private nextStepAfterFailedDineInAuth() {
    const store = this.selectedStore || this.storeInfo;
    const key =
      store && store.dine_in_disable_table_selection
        ? "open_camera_and_scan_table_qr"
        : "errorMessages.please_select_a_dinein_table";
    const text = this.dineinTableLabelService.instant(key);
    // No MissingTranslationHandler is configured, so an unresolved key reaches
    // the customer verbatim. Say nothing rather than show a raw key.
    return text && text !== key ? "<br><br>" + text : "";
  }

  // setDineInAndSelectedTable persists the table before the auth outcome is
  // known (see the dispatch block after the auth call), so a failure leaves a
  // dine-in table with nobody behind it: the cart shows the table AND
  // LOGIN/REGISTER, and loadDeliveryMethodAddress restores that state on every
  // refresh because it is gated on store.dinein alone. Nothing else clears it,
  // so the customer cannot escape. Undo the persist here.
  private rollbackDineInTableAfterFailedAuth(
    selectedTable,
    authAttemptId,
    authAttemptStoreId
  ) {
    // Nothing here may throw — this runs immediately before `return error` in
    // the error branch, and an escaping error would swallow that path.
    try {
      // This callback can land up to ~30s late (timeout 10s inside retry 2), so
      // a newer attempt may already be running. It re-persists the table at its
      // own START but writes mo_token only if it SUCCEEDS, so for the whole of
      // its flight the token check below cannot distinguish it from an
      // abandoned attempt — and the table_id would match, because it wrote the
      // same table. Clearing then would strip the winner's selection and leave
      // a live guest session with no delivery method at all, since the success
      // branch never re-dispatches the table. Superseded attempts stop here.
      if (authAttemptId !== DineInModalComponent.dineInAuthAttemptSeq) {
        return;
      }

      let sessionGone = false;
      this.store
        .select("auth")
        .pipe(first())
        .subscribe((authState: any) => {
          sessionGone = !!(
            authState &&
            !authState.user &&
            !authState.mo_token
          );
        })
        .unsubscribe();
      // A session that arrived by any other route owns the state now. This is a
      // sufficient, not a necessary, condition — but the gap is narrower than
      // it looks. A dine-in guest's token is never persisted: the success
      // branch above dispatches SetMoToken straight into the store, while the
      // only writer of localStorage.mo_token is save_mo_token (app.component),
      // so a refresh always leaves this guard satisfied. Only a token from
      // another login flow survives a boot, and that one is cleared solely on a
      // 401 — so a customer carrying such a dead token skips the rollback and
      // stays in the dead end. Pre-existing behaviour rather than a regression,
      // and widening the guard would risk clearing live sessions: worse trade.
      if (!sessionGone) {
        return;
      }

      // table_id is unique only within a store, and this modal supports
      // switching stores mid-flow.
      let currentStoreId = null;
      this.store
        .select("currentStore")
        .pipe(first())
        .subscribe((state: any) => {
          currentStoreId =
            state && state.currentStoreId != null
              ? state.currentStoreId.toString()
              : null;
        })
        .unsubscribe();
      if (
        authAttemptStoreId &&
        currentStoreId &&
        authAttemptStoreId !== currentStoreId
      ) {
        return;
      }

      let currentTable = null;
      this.store
        .select("deliveryMethodAddress")
        .pipe(first())
        .subscribe((state: any) => {
          // Gated on dineIn, as the dangling-session probe is: a table left
          // behind while another delivery method is active is not ours to
          // clear, and clearDeliveryMethod also nulls selectedAddress — which
          // this method never wrote.
          currentTable = state && state.dineIn ? state.selectedDineInTable : null;
        })
        .unsubscribe();
      if (
        !currentTable ||
        !selectedTable ||
        currentTable.table_id == null ||
        selectedTable.table_id == null ||
        currentTable.table_id.toString() !== selectedTable.table_id.toString()
      ) {
        return;
      }

      // Clears dineIn, orderPickup and the table to null — the reducer's
      // initial state — in the store AND in localStorage. Nulling only dineIn
      // would leave orderPickup at the false written alongside it, and that
      // (false, null) pair matches no validator.
      //
      // It reaches wider than those three: selectedAddress and validStores go
      // too. Neither is a no-op by accident — selectedAddress was already
      // nulled by the persist block on this exact path, and validStores is a
      // delivery-address artefact that selected-address.service rebuilds on the
      // next address validation. Nothing dine-in reads either one.
      this.dineInValidationsService.clearDeliveryMethod();
      // clearDeliveryMethod leaves dineInOrderStartTimestamp behind, and with
      // it a live interval that eventually reaches clearDineInAndStartOver —
      // which also empties the cart.
      this.dineInValidationsService.clearDineInOrderStartTimestamp();
    } catch (e) {}
  }

  private shouldUseOnlyDineInModeForTable(table, currentUser = this.currentUser) {
    if (!table || !table.connected_mobile) {
      return false;
    }

    if (!currentUser) {
      return true;
    }

    if (!currentUser.only_dinein) {
      return false;
    }

    if (!this.isCurrentOnlyDineInUserOnSameTable(table, currentUser)) {
      return true;
    }

    return this.shouldRefreshSameOnlyDineInTable(table, currentUser);
  }

  private shouldLogoutBeforeOnlyDineInAuth(selectedTable) {
    return !!(
      this.currentUser &&
      this.currentUser.only_dinein &&
      selectedTable &&
      selectedTable.connected_mobile &&
      this.currentUser.mobile &&
      this.currentUser.mobile.toString() !==
        selectedTable.connected_mobile.toString()
    );
  }

  private shouldRefreshSameOnlyDineInTable(table, currentUser = this.currentUser) {
    return !!(
      this.isStrictWebOnlyDineInStore() &&
      this.selectedTableIdFromLink &&
      table.table_id != null &&
      table.table_id.toString() === this.selectedTableIdFromLink.toString() &&
      this.isCurrentOnlyDineInUserOnSameTable(table, currentUser)
    );
  }

  private shouldAutoSubmitOnlyDineInTable(
    table,
    currentUser = this.currentUser
  ) {
    return !!(
      this.isStrictWebOnlyDineInStore() &&
      this.selectedTableIdFromLink &&
      table &&
      table.connected_mobile &&
      table.table_id != null &&
      table.table_id.toString() === this.selectedTableIdFromLink.toString() &&
      currentUser &&
      currentUser.only_dinein &&
      this.shouldUseOnlyDineInModeForTable(table, currentUser)
    );
  }

  private isCurrentOnlyDineInUserOnSameTable(
    table,
    currentUser = this.currentUser
  ) {
    return !!(
      currentUser &&
      currentUser.only_dinein &&
      currentUser.mobile &&
      table &&
      table.connected_mobile &&
      currentUser.mobile.toString() === table.connected_mobile.toString()
    );
  }

  private isStrictWebOnlyDineInStore() {
    const selectedStore = this.selectedStore || this.storeInfo;
    return !!(
      selectedStore &&
      selectedStore.dinein &&
      selectedStore.dine_in_disable_table_selection &&
      selectedStore.only_visitors_app &&
      !selectedStore.onlyAppsDineIn &&
      !Capacitor.isNativePlatform()
    );
  }

  private findStoreById(storeId) {
    if (!this.stores || storeId === null || storeId === undefined) {
      return null;
    }

    return _.find(this.stores, (store) => {
      return !!(
        store &&
        store.store_id !== null &&
        store.store_id !== undefined &&
        store.store_id.toString() === storeId.toString()
      );
    });
  }

  private findTableById(tableId) {
    if (!this.tables || tableId === null || tableId === undefined) {
      return null;
    }

    return _.find(this.tables, (table) => {
      return !!(
        table &&
        table.table_id !== null &&
        table.table_id !== undefined &&
        table.table_id.toString() === tableId.toString()
      );
    });
  }

  private shouldSendDineInLinkFootprints() {
    return !!(this.selectedTableIdFromLink || this.dineInSourceFromLink);
  }

  private sendDineInFootprint(actionId, result = null, extraData = null) {
    if (!this.shouldSendDineInLinkFootprints()) {
      return;
    }

    const selectedStoreId =
      this.selectedStoreId ||
      this.selectedStoreFromLink ||
      this.currentStoreId ||
      (this.selectedStore ? this.selectedStore.store_id : null);
    const selectedTableId =
      this.selectedTableIdFromLink ||
      this.selectedTableId ||
      (this.selectedDineInTable ? this.selectedDineInTable.table_id : null);

    this.analyticsService.dmAnalyticsCustomMessage(actionId, {
      store_id: selectedStoreId,
      table_id: selectedTableId,
      source: this.dineInSourceFromLink || "branch",
      result: result,
      ...(extraData || {}),
    });
  }

  private fetchDineInTablesThrottle = _.throttle(
    (store_id) => {
      this.fetchDineInTables(store_id);
    },
    200,
    { leading: true, trailing: false }
  );

  getDeviceId() {
    return new Promise((resolve) => {
      this.store
        .select("platformInfo")
        .pipe(first())
        .subscribe((state) => {
          resolve(state.device_id || null);
        });
    });
  }

  getUser() {
    return new Promise((resolve) => {
      this.store
        .select("auth")
        .pipe(first())
        .subscribe((state) => {
          resolve(state.user || null);
        });
    });
  }

  async fetchDineInTables(store_id) {
    this.fetchTablesLoading = true;
    this.selectedTableFromLinkObject = null;
    if (this.selectedTableIdFromLink) {
      this.selectedTableId = null;
    }
    this.updateMandatoryWebOnlyDineInModal();
    const device_id = await this.getDeviceId();
    const currentUser = await this.getUser();
    if (!_.isEqual(this.currentUser, currentUser)) {
      this.currentUser = _.cloneDeep(currentUser);
    }

    this.dataStorageService
      .getDineInTables(this.groupApp.group, store_id, device_id)
      .subscribe({
        next: async (res: any) => {
          this.fetchTablesLoading = false;
          if (!res || !res.success) {
            this.displayOnlySpinnerDisabled();
            this.sendDineInFootprint("dinein_table_fetch_result", "failed", {
              selected_table_found: false,
              tables_count: 0,
              only_dinein_auth_received: false,
            });
            const alert = await this.alertController.create({
              header: this.translateService.instant("alert"),
              message:
                res && res.comment_id
                  ? this.translateService.instant(res.comment_id)
                  : this.translateService.instant(
                      "errorMessages.general_error"
                    ),
              backdropDismiss: false,
              buttons: ["OK"],
            });

            await alert.present();
          } else {
            if (res && res.onlyDineInAuth) {
              this.auth_key = res.onlyDineInAuth;
            }

            this.tables = _.filter(res.tables || [], (table) => {
              return !!table.active;
            });
            const selectedTableFromLink = this.findTableById(
              this.selectedTableIdFromLink
            );
            this.sendDineInFootprint("dinein_table_fetch_result", "success", {
              selected_table_found: !!selectedTableFromLink,
              tables_count: this.tables ? this.tables.length : 0,
              only_dinein_auth_received: !!res.onlyDineInAuth,
            });

            if (
              this.tables &&
              this.tables.length === 1 &&
              !this.selectedTableIdFromLink
            ) {
              const uniqueTable: any = _.first(this.tables);
              this.selectedTableId = _.cloneDeep(uniqueTable.table_id);
              if (
                this.shouldAutoSubmitOnlyDineInTable(uniqueTable, currentUser)
              ) {
                this.submitSingleTable(true);
                return;
              }

              if (
                currentUser ||
                (!currentUser && !this.tables[0].connected_mobile)
              ) {
                if (this.submitSingleTable(false)) {
                  return;
                }
              }
            }

            if (
              this.selectedTableIdFromLink &&
              this.tables &&
              selectedTableFromLink
            ) {
              console.log("table found");
              this.selectedTableId = _.cloneDeep(this.selectedTableIdFromLink);
              this.selectedTableFromLinkObject =
                _.cloneDeep(selectedTableFromLink);
              if (this.tables && this.tables.length === 1) {
                if (
                  this.shouldAutoSubmitOnlyDineInTable(
                    this.selectedTableFromLinkObject,
                    currentUser
                  )
                ) {
                  this.submitSingleTable(true);
                  return;
                }

                if (
                  currentUser ||
                  (!currentUser && !selectedTableFromLink.connected_mobile)
                ) {
                  if (this.submitSingleTable(false)) {
                    return;
                  }
                }
              }
              this.displayOnlySpinnerDisabled();
            } else {
              this.displayOnlySpinnerDisabled();
              console.log("table not found");
              if (
                this.selectedTableIdFromLink &&
                this.isDineInScanFallbackSource()
              ) {
                this.sendDineInFootprint(
                  "dinein_table_selection_result",
                  "table_not_found",
                  {
                    selected_table_found: false,
                  }
                );
                await this.presentDineInTableRecognitionFailedAlert();
              }
            }

            this.checkOnlyDineInModeTable();
            this.updateMandatoryWebOnlyDineInModal();
          }
        },
        error: async (error) => {
          this.displayOnlySpinnerDisabled();
          this.fetchTablesLoading = false;
          this.updateMandatoryWebOnlyDineInModal();
          this.sendDineInFootprint("dinein_table_fetch_result", "error", {
            selected_table_found: false,
            tables_count: 0,
            only_dinein_auth_received: false,
          });
          const alert = await this.alertController.create({
            header: this.translateService.instant("alert"),
            message: this.translateService.instant(
              "errorMessages.problem_reaching_server"
            ),

            buttons: ["OK"],
          });
          await alert.present();
          return error;
        },
      });
  }

  // The quiet submit is for a QR/link arrival only, while the card is still
  // hidden and the modal can really submit: without stores clickOkButton does
  // nothing, and the only-dine-in auth reads selectedStore. Otherwise the card
  // is revealed and clickOkButton runs exactly as it did before, so every other
  // path (the order-now popup, a store picked by hand on the visible card)
  // keeps its old behaviour. Returns true when the quiet submit took over.
  private submitSingleTable(onlyDineInMode) {
    if (
      this.selectedStoreFromLink &&
      this.displayOnlySpinner &&
      this.stores &&
      this.stores.length &&
      (!onlyDineInMode || this.selectedStore)
    ) {
      this.clickOkButton(onlyDineInMode, true);
      return true;
    }

    this.displayOnlySpinnerDisabled();
    this.clickOkButton(onlyDineInMode);
    return false;
  }

  private isDineInScanFallbackSource() {
    return (
      this.dineInSourceFromLink === "branch_query_fallback" ||
      this.dineInSourceFromLink === "tolink_direct"
    );
  }

  private async presentDineInTableRecognitionFailedAlert() {
    if (this.dineInScanRecognitionAlertPresented) {
      return;
    }

    this.dineInScanRecognitionAlertPresented = true;
    const messageKey =
      "errorMessages.dinein_table_recognition_failed_disable_adblock";
    const translatedMessage = this.dineinTableLabelService.instant(messageKey);
    const message =
      translatedMessage && translatedMessage !== messageKey
        ? translatedMessage
        : this.dineinTableLabelService.instant("dinein_table_not_found");

    const alert = await this.alertController.create({
      header: this.translateService.instant("alert"),
      message,
      backdropDismiss: false,
      buttons: ["OK"],
    });

    await alert.present();
  }

  async onStoreSelection(ev) {
    const storesForSelection = _.cloneDeep(this.stores);

    _.each(storesForSelection, (store) => {
      if (store && store.dinein) {
        store.hasTheOffer = true;
      }
    });

    const selected_store_id: any = await this.openSelectStoreModal(
      _.cloneDeep(storesForSelection)
    );

    if (selected_store_id) {
      this.selectedStoreId = _.cloneDeep(selected_store_id);
      this.changeStore("");
    }
  }

  async openSelectStoreModal(storesForSelection) {
    return new Promise(async (resolve, reject) => {
      let cssClass = "selectStorePopupCss";
      if (
        storesForSelection &&
        storesForSelection.length > 1 &&
        storesForSelection.length <= 3
      ) {
        cssClass = "selectStorePopupCssThreeStores";
      } else if (storesForSelection && storesForSelection.length > 3) {
        cssClass = "selectStorePopupCssMultipleStores";
      }
      const modal = await this.modalController.create({
        component: SelectStorePopupComponent,
        componentProps: {
          storesForSelection: storesForSelection,
          forDineinSelection: true,
          onlyReturnSelectedStoreId: true,
        },
        cssClass: cssClass,
        backdropDismiss: false,
      });

      await modal.present();

      await modal.onDidDismiss().then((data) => {
        if (data && data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      });
    });
  }

  displayOnlySpinnerEnabled() {
    this.displayOnlySpinner = true;

    // Own host only. The document lookups below take the first match, which
    // can be another modal (e.g. the startup splash screen one).
    if (this.modal) {
      if (this.modal.classList.contains("dineInModal")) {
        this.modal.classList.remove("dineInModal");
        this.modal.classList.add("dineInModalTransparent");
        this.modal.classList.add("fullscreen");
      }
      return;
    }

    const modalElements = document.getElementsByClassName("dineInModal");

    if (
      modalElements &&
      modalElements.item &&
      modalElements.item.length === 1
    ) {
      const element = modalElements[0];

      if (element) {
        element.classList.remove("dineInModal");
        element.classList.add("dineInModalTransparent");

        const modalEl = document.querySelector("ion-modal") as HTMLElement;

        if (modalEl) {
          modalEl.classList.add("fullscreen");
        }
      }
    }
  }

  displayOnlySpinnerDisabled() {
    if (this.modal) {
      if (this.modal.classList.contains("dineInModalTransparent")) {
        this.modal.classList.remove("dineInModalTransparent");
        this.modal.classList.add("dineInModal");
        this.modal.classList.remove("fullscreen");
      }
      this.displayOnlySpinner = false;
      return;
    }

    const modalElements = document.getElementsByClassName(
      "dineInModalTransparent"
    );

    if (
      modalElements &&
      modalElements.item &&
      modalElements.item.length === 1
    ) {
      const element = modalElements[0];

      if (element) {
        element.classList.remove("dineInModalTransparent");
        element.classList.add("dineInModal");

        const modalEl = document.querySelector("ion-modal") as HTMLElement;

        if (modalEl) {
          modalEl.classList.remove("fullscreen");
        }
      }
    }

    this.displayOnlySpinner = false;
  }

  ngOnDestroy(): void {
    if (this.dineinTableContextSub) {
      this.dineinTableContextSub.unsubscribe();
    }
    this.tables = null;
    this.selectedTableId = null;
    this.selectedStoreId = null;

    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }

    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }
}
